<template>
  <section class="section container pt-0">
    <templates-datatable />
  </section>
</template>

<script>
import TemplatesDatatable from "./templates_datatable/Index.vue";

export default {
  name: "LandingTemplates",
  components: {
    TemplatesDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
